const BASE_PATH = "app/admin/chats/";

export const SET_USERS = `${BASE_PATH}set-users`;
